import { SizeType } from "antd/es/config-provider/SizeContext"
import { FilterDropdownProps } from "antd/es/table/interface"
import { capitalizeFirstLetter } from "helpers/utils.helper"
import { Checkbox } from "antd"
import { BandgeStatus } from "components/ui/bandges/BadgeStatus/BadgeStatus"
import { TBadge } from "types/badges.type"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { useFillesTableStore } from "store/table.store"
import { useState, type Key } from "react"
import style from "./CustomStatusFilter.module.scss"

const { badgeStatus, optionsWrapper, checkboxGroup } = style

interface FilterOption {
	text: string
	value: string
	children?: FilterOption[]
}

interface Props extends FilterDropdownProps {
	filteredOptions: FilterOption[]
	size?: SizeType
	dataIndex: string
	clearFilters: () => void
	selectedKeys: Key[]
}

export const CustomStatusFilter = ({
	filteredOptions,
	selectedKeys,
	setSelectedKeys,
	clearFilters,
	confirm,
	dataIndex,
}: Props) => {
	const { setFilter } = useFillesTableStore()
	const [statuses, setStatuses] = useState<Key[]>([])

	// Change statuses
	const changeHandle = (e: Key[]) => {
		setSelectedKeys(e)
		setStatuses(e)
	}

	// Clear filter
	const clearHandle = () => {
		clearFilters()
		setFilter({ status: [] })
		localStorage.removeItem("status")
		confirm()
	}

	const applyFilterHandle = () => {
		setFilter({ status: statuses })
		localStorage.setItem("status", JSON.stringify(statuses))
		confirm()
	}

	return (
		<div className="customFilter">
			<div className="filterHeader">
				<span className="filterName">{capitalizeFirstLetter(dataIndex)}</span>
				<button className="cleanButton" onClick={clearHandle}>
					Clean
				</button>
			</div>
			<div data-testid="status-filter">
				<Checkbox.Group value={selectedKeys} onChange={changeHandle} className={checkboxGroup}>
					<div className={optionsWrapper}>
						{filteredOptions.map(
							(option) =>
								option && (
									<Checkbox key={option.value} value={option.value} className="statusCheckbox">
										<BandgeStatus type={option.value as TBadge} className={badgeStatus} />
									</Checkbox>
								),
						)}
					</div>
					<ButtonPrimary onClick={applyFilterHandle}>Apply filter</ButtonPrimary>
				</Checkbox.Group>
			</div>
		</div>
	)
}
